var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMeestPortalLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 22,
    fill: "none",
    viewBox: "0 0 16 22",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0061AF",
    d: "M4.7455 13.9939H0V7.9663h4.7595l1.6286 2.9855z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E60033",
    d: "m9.0396 0 5.981 10.9516-5.981 11.0224h-5.981l5.981-11.0224L3.0586 0z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMeestPortalLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/meest-portal-logo.3c8dd0c0ade03bab5b15298c6389a7aa.svg";